// legalVersions.js — PLATFORM-002 / ADR-058 (clickwrap enforcement)
//
// Frontend MIRROR of the authoritative backend legal-version constants
// (netlify/functions/_shared/legalVersions.js). Parity is guarded by
// backend/tests/legalVersionsParity.test.js so the gate the client shows and
// the version the server records can never drift.
//
// Also exports the pure gate helper the acceptance gate uses to decide whether
// a signed-in user must (re-)accept before reaching protected functionality.

export const TERMS_VERSION = 'v1.2';
export const PRIVACY_VERSION = 'v1.2';

/**
 * True only when the profile records acceptance of BOTH the current Terms and
 * the current Privacy Policy (version match + a timestamp). A null/absent
 * profile, a missing timestamp, or a stale version → false (gate shown).
 * Bumping either version in legalVersions requires re-acceptance.
 */
export function hasAcceptedCurrentLegal(profile) {
  if (!profile) return false;
  return (
    profile.accepted_terms_version === TERMS_VERSION &&
    profile.accepted_privacy_version === PRIVACY_VERSION &&
    Boolean(profile.accepted_terms_at) &&
    Boolean(profile.accepted_privacy_at)
  );
}
